import { Notyf } from 'notyf';

class NotificationType {
  constructor(type) {
    this.type = type;
    this.className = `toast ${type}_toast`;
    this.ripple = false;
    this.icon = {
      className: 'icon',
      tagName: 'i',
      text: ''
    };
  }
}

const notificationTypes = [
  new NotificationType('info'), 
  new NotificationType('warning'), 
  new NotificationType('error')
];

window.notify = new Notyf({
  types: notificationTypes,
  duration: 4000,
})

